import { useReducedMotion } from 'motion/react';

/**
 * Centralized motion configuration.
 * All animated components should use this instead of raw Framer props.
 *
 * When reduced motion is preferred:
 *   - duration → 0
 *   - spring → instant
 *   - layout animations → disabled
 */
export function useMotionConfig() {
    const prefersReducedMotion = useReducedMotion();

    return {
        prefersReducedMotion,
        /** Transition preset for modals/overlays */
        overlay: prefersReducedMotion
            ? { duration: 0 }
            : { type: 'spring' as const, stiffness: 500, damping: 35 },
        /** Transition preset for subtle UI (toasts, chips) */
        subtle: prefersReducedMotion
            ? { duration: 0 }
            : { duration: 0.2, ease: [0.2, 0, 0, 1] as const },
        /** Transition preset for layout morphs (Barry FAB → panel) */
        morph: prefersReducedMotion
            ? { duration: 0 }
            : { type: 'spring' as const, stiffness: 200, damping: 18 },
    };
}
